/** Resize a browser image to a JPEG, preserving its aspect ratio. Browser APIs
 * are injectable so geometry and encoding can be tested without a real camera.
 */
export async function resizeImageFile(file, {
  createImageBitmap: makeBitmap = (value) => createImageBitmap(value),
  createCanvas = () => document.createElement('canvas'),
  maxSide = 1280,
} = {}) {
  const bitmap = await makeBitmap(file);
  const scale = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height));
  const canvas = createCanvas();
  canvas.width = Math.max(1, Math.round(bitmap.width * scale));
  canvas.height = Math.max(1, Math.round(bitmap.height * scale));
  const context = canvas.getContext('2d');
  context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  if (bitmap.close) bitmap.close();
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('No se pudo procesar la imagen.'))), 'image/jpeg', 0.85);
  });
}
